"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireWildcard(require("react-dom"));

var _ = require("_");

var _tether = _interopRequireDefault(require("tether"));

var _UITetherOptions = require("./UITetherOptions");

function makeLayerNode() {
  var node = document.createElement('div'); // add z-index for compatibility with other "layered" stuff like vex

  node.style.zIndex = 1111; // position fixed prevents a screen jump when the container mounts

  node.style.position = 'fixed';
  node.style.top = '0px';
  return node;
}

function callIfPossible(subject) {
  if (typeof subject !== 'function') {
    return subject;
  }

  return subject();
}

var ATTACHMENTS_HORIZ = ['left', 'center', 'right'];
var ATTACHMENTS_VERT = ['top', 'middle', 'bottom'];
var TARGET_MODIFIERS = ['scroll-handle', 'visible'];
/**
 * A positioning engine to make overlays, tooltips and dropdowns better.
 *
 * The element to be moved is called the 'element'. The element in the page it's to be attached to is called the 'target'.
 * To use Tether, you define a point on the target and a point on the element. Tether moves the element to keep those two points on top of each other.
 *
 * @example UITether/examples
 * @category Utility
 **/

var _default = _react.default.createClass({
  displayName: "UITether",
  propTypes: {
    /**
     * Where to align the attachment point on the horizontal part of the element (top, middle, bottom)
     **/
    attachmentHoriz: _react.PropTypes.oneOf(ATTACHMENTS_HORIZ).isRequired,

    /**
     * Where to align the attachment point on the vertical part of the element (left, center, right)
     **/
    attachmentVert: _react.PropTypes.oneOf(ATTACHMENTS_VERT).isRequired,

    /**
     * With scrollable regions, t's pretty easy to scroll in such a way that the element is hanging out on its own, with no target in sight.
     * Constraints allow you to control what happens when the tethered element would have to fall outside of a defined region to maintain the attachment.
     **/
    constraints: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      attachment: _react.PropTypes.string,
      pin: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.arrayOf(_react.PropTypes.oneOf(['bottom', 'left', 'right', 'top']))]),
      to: _react.PropTypes.oneOf(['window', 'scrollParent']).isRequired
    }).isRequired),

    /**
     * Adjust the location of the attachment point horizontally toward/away from the element
     **/
    offsetHoriz: _react.PropTypes.number.isRequired,

    /**
     * * Adjust the location of the attachment point vertically toward/away from the element
     **/
    offsetVert: _react.PropTypes.number.isRequired,

    /**
     * The element in the page to be attached to (use this or pass element as only child)
     *
     * Can be a function, which is useful for requiring refs from the parent component
     **/
    target: _react.PropTypes.oneOfType([_react.PropTypes.func.isRequired, _react.PropTypes.instanceOf(HTMLElement).isRequired]),

    /**
     * The element in the page to be attached to (use this or pass the explicit `target` prop above)
     **/
    children: _react.PropTypes.oneOfType([_react.PropTypes.node.isRequired, _react.PropTypes.func.isRequired]).isRequired,

    /**
     * Where to align the attachment point on the horizontal part of the target (left, center, right)
     **/
    targetAttachmentHoriz: _react.PropTypes.oneOf(['auto'].concat(ATTACHMENTS_HORIZ)),

    /**
     * Where to align the attachment point on the vertical part of the target (top, middle, bottom)
     **/
    targetAttachmentVert: _react.PropTypes.oneOf(['auto'].concat(ATTACHMENTS_VERT)),

    /**
     * Special attachment modifiers: 'scroll-handle' or 'visible'
     **/
    targetModifier: _react.PropTypes.oneOf(TARGET_MODIFIERS),

    /**
     * Adjust the location of the attachment point horizontally toward/away from the target
     **/
    targetOffsetHoriz: _react.PropTypes.number.isRequired,

    /**
     * Adjust the location of the attachment point vertically toward/away from the target
     **/
    targetOffsetVert: _react.PropTypes.number.isRequired,

    /**
     * The UI element you wish to pin to the target
     **/
    content: _react.PropTypes.oneOfType([_react.PropTypes.node.isRequired, _react.PropTypes.func.isRequired]).isRequired,

    /**
     * Toggle visibility by actually mounting/unmounting the target in the DOM
     **/
    tetherOpen: _react.PropTypes.bool.isRequired,

    /**
     * Lifecycle hook: called just after tether mounts into the DOM
     **/
    tetherDidMount: _react.PropTypes.func,

    /**
     * Lifecycle hook: called just after tether properties have updated
     **/
    tetherDidUpdate: _react.PropTypes.func,

    /**
     * Lifecycle hook: called just prior to tether mounting into the DOM
     **/
    tetherWillMount: _react.PropTypes.func,

    /**
     * Lifecycle hook: called just prior to tether UNmounting from the DOM
     **/
    tetherWillUnmount: _react.PropTypes.func,

    /**
     * Container element in which Tether will operate (defaults to window)
     *
     * Useful for sandboxing Tether to just a portion of the DOM.
     **/
    parentNode: _react.PropTypes.instanceOf(HTMLElement).isRequired
  },
  componentDidMount: function componentDidMount() {
    if (this.props.tetherOpen) {
      this.mountTether();
    }
  },
  componentDidUpdate: function componentDidUpdate(oldProps) {
    var tetherOpen = this.props.tetherOpen;

    if (oldProps.tetherOpen && !tetherOpen) {
      this.unmountTether();
    } else if (!oldProps.tetherOpen && tetherOpen) {
      this.mountTether();
    } else if (oldProps.tetherOpen && tetherOpen) {
      this.updateTether();
    }
  },
  componentWillMount: function componentWillMount() {
    this.updateTetherLayer = (0, _.debounce)(this.updateTetherLayerSync);
  },
  componentWillUnmount: function componentWillUnmount() {
    this.unmountTether();
  },
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, (0, _UITetherOptions.getTetherDefaultProps)(), {
      parentNode: document.body,
      tetherOpen: true
    });
  },
  getTarget: function getTarget() {
    var target = this.props.target;

    if (target) {
      return callIfPossible(target);
    }

    return (0, _reactDom.findDOMNode)(this);
  },
  mountTether: function mountTether() {
    var _this = this;

    if (!this.isMounted()) {
      return;
    }

    this._element = makeLayerNode();
    var _this$props = this.props,
        parentNode = _this$props.parentNode,
        tetherDidMount = _this$props.tetherDidMount,
        tetherWillMount = _this$props.tetherWillMount;
    parentNode.appendChild(this._element);
    callIfPossible(tetherWillMount);
    (0, _.defer)(function () {
      return _this.updateTetherLayerSync(tetherDidMount);
    });
  },
  unmountTether: function unmountTether() {
    var _this2 = this;

    var _this$props2 = this.props,
        parentNode = _this$props2.parentNode,
        tetherWillUnmount = _this$props2.tetherWillUnmount; // defering our unmount allows any DOM events to finish propagating
    // before the tethered content is removed

    callIfPossible(tetherWillUnmount);
    (0, _.defer)(function () {
      if (_this2._tether) {
        _this2._tether.destroy();

        _this2._tether = null;
      }

      if (_this2._element) {
        parentNode.removeChild(_this2._element);

        try {
          _reactDom.default.unmountComponentAtNode(_this2._element);
        } catch (e) {// Ignore errors thrown by React here (HubSpot/UITether#14)
        }

        _this2._element = null;
      }
    });
  },
  render: function render() {
    return this.renderChildren();
  },
  renderChildren: function renderChildren() {
    return _react.Children.only(callIfPossible(this.props.children));
  },
  updateTether: function updateTether() {
    if (!this.isMounted()) {
      return;
    }

    var tetherDidUpdate = this.props.tetherDidUpdate;
    this.updateTetherLayer(tetherDidUpdate);
  },
  updateTetherLayerSync: function updateTetherLayerSync(callback) {
    var _this3 = this;

    if (!this._element || !this.isMounted()) {
      return;
    }

    _reactDom.default.unstable_renderSubtreeIntoContainer(this, callIfPossible(this.props.content), this._element, function () {
      _this3.updateTetherOptions();

      callIfPossible(callback);
    });
  },
  updateTetherOptions: function updateTetherOptions() {
    if (!this.isMounted()) {
      return;
    }

    var tetherOptions = (0, _UITetherOptions.getTetherOptions)(this.props, this._element, this.getTarget());

    if (!this._tether) {
      this._tether = new _tether.default(tetherOptions);
    } else {
      this._tether.setOptions(tetherOptions);
    }
  }
});

exports.default = _default;
module.exports = exports.default;